import React from 'react';
import { Col, Placeholder, Row } from '@thd-olt-component-react/core-ui';

const CreateJobPostingLoader = () => {
  return (
    <>
      <Row>
        <Col>
          <InputSkeleton />
        </Col>
      </Row>

      <Row>
        <Col xs="6">
          <InputSkeleton />
        </Col>
        <Col xs="6">
          <InputSkeleton />
        </Col>
      </Row>

      <Row>
        <Col xs="6">
          <InputSkeleton />
        </Col>
        <Col xs="6">
          <InputSkeleton />
        </Col>
      </Row>

      <Row>
        <Col>
          <TextFieldSkeleton />
        </Col>
      </Row>

      <Row>
        <Col>
          <TextFieldSkeleton row={3} />
        </Col>
      </Row>

      <Row>
        <Col>
          <InputSkeleton />
        </Col>
      </Row>

      <Row>
        <Col>
          <TextFieldSkeleton />
        </Col>
      </Row>

      <Row>
        <Col>
          <TextFieldSkeleton />
        </Col>
      </Row>
    </>
  );
};

const InputSkeleton = () => {
  return (
    <div style={{ marginBottom: '10px' }}>
      <div style={{ marginBottom: '10px' }}>
        <Placeholder type="rect" height="20px" width="125px" />
      </div>
      <Placeholder type="rect" height="40px" width="100%" />
    </div>
  );
};

const TextFieldSkeleton = ({ rows = 4 }) => {
  return (
    <div style={{ marginBottom: '10px' }}>
      <div style={{ marginBottom: '10px' }}>
        <Placeholder type="rect" height="20px" width="125px" />
      </div>
      <Placeholder type="rect" height={`${rows * 40}px`} width="100%" />
    </div>
  );
};

export default CreateJobPostingLoader;
